<template>
  <div class="security--container">

    <div class="shadow-card">
      <div class="text-bold">История устройств</div>
      <div class="mrg-t-10" v-if="userAgentHistory.length === 0">-</div>
      <div class="mrg-t-10 history" v-if="userAgentHistory.length > 0">
        <div class="item mrg-t-15" v-for="item in userAgentHistory" :key="item.id">
          <div>Платформа: <b>{{item.platform}}</b></div>
          <div>Браузер: <b>{{item.browser}}</b></div>
          <div>
            IP: <b>{{item.ip}}</b>
            <span v-if="item.location"> ({{item.location}})</span>
          </div>
          <div>
            Время: <b>{{convertDt(item.created_dt)}}</b>
          </div>
        </div>
      </div>
      <div class="mrg-t-30">
        Если у вас возникло подозрение, что кто-то посторонний имеет доступ к вашей учетной записи или, например,
        вы входили в программу с чужого устройства и забыли выйти,
        то можете выполнить выход со всех устройств.
      </div>
      <div class="mrg-t-10">
        <div @click="showExitAllPopup" class="btn btn-sm btn-orange">Выйти со всех устройств</div>
      </div>
    </div>

    <popup
      :closeButton="exitAllPopup.closeButton"
      :actionButton="exitAllPopup.actionButton"
      :actionClass="exitAllPopup.actionClass"
      :show="exitAllPopup.show"
      @closePopup="closeExitAllPopup"
      @actionPopup="exitAllSubmit"
    >
      <div slot="header">Выйти со всех устройств?</div>
      <div slot="body">
        Произойдет выход со всех устройств. Необходимо будет войти в учетную запись заново.
      </div>
    </popup>

  </div>
</template>

<script>

import Formatter from "../../libraries/Formatter";
import Popup from '../../Popup.vue';
import userRepository from "../../../repositories/user";

const formatter = new Formatter();

export default {
  name: "Security",
  components: { Popup },
  data() {
    return {
      userAgentHistory: [],
      exitAllPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Продолжить",
        actionClass: "btn-success"
      },
    };
  },
  props: {

  },
  watch: {},
  computed: {

  },
  methods: {
    exitAllSubmit(){
      userRepository.exitAllPlatform().then(() => {
        this.getUserAgent();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeExitAllPopup(){
      this.exitAllPopup.show = false;
    },
    showExitAllPopup(){
      this.exitAllPopup.show = true;
    },
    convertDt(datetime){
      return formatter.datetimeToRus(datetime);
    },
    getUserAgent(){
      this.$store.dispatch("startPreloader");
      userRepository.getAgentHistory().then(resp => {
        this.userAgentHistory = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    this.getUserAgent();
  }
};
</script>

<style scoped lang="less">
.security--container{
  width: 50%;
}

@media (max-width: 1400px) {
  .security--container{
    width: 100%;
  }
}
</style>
